<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zxHmYi/tc-custom/9781488015243.jpg?1726518910026" alt="This image is the cover for the book Christmas Bride for the Boss"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas Bride for the Boss
      </h1>
      <p class="bookDescription body article font2">
        <b>Wedding planner—to wife and mother?</b><br/><br/>Jamie Wallis needs a replacement nanny for his daughter—fast! So when a stunning young woman comes to him with a business proposal, he has a different proposition for her…<br/><br/>Securing Jamie’s investment is essential, but Sophie Firth wasn’t expecting to be asked to care for his daughter! However, once they meet, Sophie can’t help adoring little Sienna. And, as Christmas approaches, Sophie quickly becomes part of the family—and Jamie can’t resist letting her into his heart!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Hardy
      </h2>
      
      <p class="authorDescription body article">Kate Hardy has been a bookworm since she was a toddler. When she isn&#39;t writing Kate enjoys reading, theatre, live music, ballet and the gym. She lives with her husband, student children and their spaniel in Norwich, England. You can contact her via her website: www.katehardy.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f723ebf8